$(document).ready(function (){

    $('body').on('click', '.neighborhood_banner__hotlinks a', function (e) {
        e.preventDefault();

        const href = $(this).attr('href') || '';
        const id = href.indexOf('#') >= 0 ? href.split('#')[1] : '';
        if (!id) return;

        const $target = $('#' + id);
        if (!$target.length) return;

        if (!$target.is('[tabindex]')) {
            $target.attr('tabindex', '-1');
        }

        const offset = $target.offset().top - 144;

        this.blur();

        $('html, body').animate({ scrollTop: offset }, 500, function () {
            if ($target[0] && $target[0].focus) {
                try {
                    $target[0].focus({ preventScroll: true });
                } catch (_) {
                    // fallback для старих браузерів
                    $target.focus();
                }
            }

        });
    });
});